export default {"src":"/_next/static/media/copyDrawer.9bfe3a1c.svg","height":16,"width":13,"blurWidth":0,"blurHeight":0};